// eslint-disable-next-line
import React from 'react';
//import {Link} from 'react-router-dom';
import {getSettings,Image,is,Head,isImage} from './../../helpers';
//import join from 'join-path';
const Articles = (props)=>{
    const TitleText = (props)=>{
            return <div className="logo is-hidden-tablet">
                <h1>{props.title}</h1>
            </div>
    }
    return <div className={`articles-wrap ${props.color}`} onScroll={(e)=>console.log(e)}>
            <div  id={`article_box_${props.id}`} className="reveal active">
            {props.flip===true?
                <div className="article is-cover">
                    <div className="cover-wrap">
                        <div className="cover" style={{backgroundImage:`url('${Image(props.cover)}')`}}></div>
                     </div>
                </div>:null}
            <div className="article">
                <div className="cover-title">
                    <h1>{props.title}</h1>
                    {!is.empty(props.description)? <p>{props.description}</p> : null}
                    {!is.empty(props.text)? <a className="article-button" onClick={props.onClick} >{props.text}</a>:null}
                </div>
             </div>
             {props.flip!==true?
                  <div className="article is-cover">
                  <div className="cover-wrap" onClick={props.onClick}>
                      <div className="cover" style={{backgroundImage:`url('${Image(props.cover)}')`}}></div>
                  </div>
              </div>:null}
              </div>
    </div>
       
}
const Parallax = (props)=>{
    const phonelink= "tell:"+props.biz("phone").replace(/[^\d]/g, '');
    return <div className="top-cover-wrap">
        <div className="top-slider">
            <img className="top-cover is-desktop" src={Image(props.cover)}/>
            <img className="top-cover is-tablet" src={Image(props.tabletcover)}/>
            <img className="top-cover is-mobile" src={Image(props.mobilecover)}/>
            <div className="top-cover-link">
                <a href={phonelink}>CALL: {props.biz("phone")}</a>
            </div>
        </div>
    </div>
}
const Landing = (props) =>{
    const biz = getSettings("address",props.settings);
    const theme = getSettings("theme",props.settings);
    const home = getSettings("home",props.settings.pages);

    Head.title(`${biz("bizname")} | ${biz("address")}`);
    //const pages = props.pages;
    //const page = pages[props.page];
    const cover = theme("cover") || "";
    const tabletcover = theme("tabletcover") || "";
    const mobilecover = theme("mobilecover") || "";
    const logo = theme("logo")|| "";
    const classLogo = theme("classLogo") || "";        
    //const mapLink = "https://www.google.com/maps/search/?api=1&query="+encodeURI(biz("address"));
    return <section className="section no-padding is-white">
                <Parallax 
                    biz={biz} 
                    title={ biz("bizname")} 
                    logoClass={classLogo} 
                    logo={logo} 
                    cover={cover} 
                    tabletcover={tabletcover} 
                    mobilecover={mobilecover}
                />
                {[0,1,2,3].map((k, i) =>{
                    const image  = home(`${k}_image`);
                    const title  = home(`${k}_title`);
                    const link  = home(`${k}_link`);
                    const color  = home(`${k}_color`);
                    const text   =  home(`${k}_text`);
                    const description = home(`${k}_description`);
                    const flip   = i%2 === 0 ? true : false;
                    
                    if(isImage(image)){
                        return <Articles 
                            flip={flip} 
                            id={i} 
                            biz={biz}
                            key={k} 
                            text={text} 
                            onClick={()=> props.history.push(link)} 
                            color={color} 
                            description={description} 
                            title={title} 
                            cover={image} 
                            tabletcover={tabletcover} 
                            mobilecover={mobilecover}
                            />
                    }
                    return null;
                })}
            </section>
}
export default Landing;


// WEBPACK FOOTER //
// ./src/components/themes/Home.js